import React from 'react';
import { useSelector } from 'react-redux';

import {
  Container,
  Lottie,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  LanguageSwitchWrapper,
  NewsletterSignup,
} from '../../components';

// Import like this to avoid dependency cycle.
import ContactFooterMenu from '../Menu/ContactFooterMenu';
import FooterMenu from '../Menu/FooterMenu';
import SecondaryFooterMenu from '../Menu/SecondaryFooterMenu';

import './style.scss';

const Footer = () => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));
  const lang = useSelector((state) => state.getIn(['ui', 'language']));

  return (
    <footer className="Footer">
      <div className="Footer__newsletter__wrapper">
        <NewsletterSignup />
      </div>
      <div className="Footer__main__wrapper">
        <Container className="Footer__main">
          <div className="Footer__main__logo">
            <CoreLink
              to={`/${lang}/`}
            >
              <div className="Footer__main__logo__text" />
            </CoreLink>
          </div>
          <FooterMenu currentPage={currentPage} />
          <div className="FooterAddress col-12">
            <ContactFooterMenu currentPage={currentPage} />
          </div>
          <div className="Footer__super_footer">
            <LanguageSwitchWrapper />
            <SecondaryFooterMenu currentPage={currentPage} />
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
